import { createSelector } from '@reduxjs/toolkit';
import { ERoomType } from '../../../../packages/JsonQuery';
import { selectRoomType } from 'shared/selectors/jsonQuery';
import { capitalize } from 'shared/utils/string';
import { getCommonRoomTypeNames, getSpecialRoomTypeNames } from './utils';

export const selectRoomTypeLabel = createSelector(selectRoomType, roomTypes => {
  if (!roomTypes) {
    return '';
  }

  const commonRoomTypeNames = getCommonRoomTypeNames(roomTypes);
  const specialRoomTypeNames = getSpecialRoomTypeNames(roomTypes);

  let postfix = '';

  if (commonRoomTypeNames.length > 0) {
    postfix =
      !specialRoomTypeNames.length &&
      commonRoomTypeNames.length === 1 &&
      !roomTypes.includes(ERoomType.FlatManyRooms) &&
      !commonRoomTypeNames[0].includes('-')
        ? '-комнатную'
        : ' комн.';
  }

  const roomTypeName = [commonRoomTypeNames.join(', ') + postfix, specialRoomTypeNames.join(', ')]
    .filter(Boolean)
    .join(', ');

  return (roomTypeName && capitalize(roomTypeName)) || '';
});
